import { render, staticRenderFns } from "./SingleMessage.vue?vue&type=template&id=7aa27659&scoped=true&"
import script from "./SingleMessage.vue?vue&type=script&lang=js&"
export * from "./SingleMessage.vue?vue&type=script&lang=js&"
import style0 from "./SingleMessage.vue?vue&type=style&index=0&id=7aa27659&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa27659",
  null
  
)

export default component.exports